import React from 'react';

export const BedSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M35 8C34.447 8 34 8.447 34 9V16H2V1C2 0.448 1.553 0 1 0C0.447 0 0 0.448 0 1V23C0 23.553 0.447 24 1 24C1.553 24 2 23.553 2 23V21H34V23C34 23.553 34.447 24 35 24C35.553 24 36 23.553 36 23V9C36 8.447 35.553 8 35 8Z" fill={color} />
        <path d="M30.8679 10.7128L15.5952 10C12.0955 10 11.2315 13.5 11.2315 13.5H10.1406V17H34.1406V12.3333C34.1406 11.2104 32.9679 10.7128 30.8679 10.7128Z" fill={color} />
        <path d="M12.8116 11H4C2.896 11 2 11.896 2 13V17H12L12.8116 11Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M35 8C34.447 8 34 8.447 34 9V16H2V1C2 0.448 1.553 0 1 0C0.447 0 0 0.448 0 1V23C0 23.553 0.447 24 1 24C1.553 24 2 23.553 2 23V21H34V23C34 23.553 34.447 24 35 24C35.553 24 36 23.553 36 23V9C36 8.447 35.553 8 35 8Z" fill="#E4551D" />
      <path d="M30.8679 10.7128L15.5952 10C12.0955 10 11.2315 13.5 11.2315 13.5H10.1406V17H34.1406V12.3333C34.1406 11.2104 32.9679 10.7128 30.8679 10.7128Z" fill="#35AAEC" />
      <path d="M12.8116 11H4C2.896 11 2 11.896 2 13V17H12L12.8116 11Z" fill="#BDDDF4" />
    </svg>
  )
}